const BlogItem = ({ img, title, summary, url }) => (
  <div className="contentful__blog-item bg-white fl fl-col">
    <div dangerouslySetInnerHTML={{ __html: img }} />
    <div className="fl fl-col fl-grow-1 plr-16 ptb-25">
      <h3 className="h4">{title}</h3>
      <p className="tc-secondary pb-16" style={{ marginBottom: 'auto' }}>
        {summary}
      </p>
      <a
        href={`https://www.cef.co.uk/${url}`}
        className="fs-16 fw-600 lh-1-5 td-u"
        target="_blank"
        rel="noreferrer">
        Read more
      </a>
    </div>
  </div>
);

export default BlogItem;
